import {client} from '../axios';

import {User, WalletItem} from "@/types/UserType";
import {ResponseError} from "@/types";
import {resolveError} from "@/data/_resolveError";

export const fetchUser = (
    success = (user: User) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/user`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const updateSettings = (
    form: User,

    success = (data: {status: string, data: {slug: string}}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/user/settings`, form)
        .then(({data}: any) => {
            success(data);
        }).catch((error) => resolveError(error, failed));
}

export const updateSecurity = (
    form: { current_password: string | null, password: string | null, password_confirmation: string | null },

    success = (data: {status: string, data: {slug: string}}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/user/settings/security`, form)
        .then(({data}: any) => {
            success(data);
        }).catch((error) => resolveError(error, failed));
}

export const fetchWallet = (
    success = (wallet: WalletItem[]) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/user/wallet`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const deleteWalletCard = (
    key: string,

    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/user/wallet/${key}/delete`)
        .then(() => {
            success();
        }).catch((error) => resolveError(error, failed));
}

export const addWalletCard = (
    success = (data: {url: string}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/user/wallet/add`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const updateAvatar = (
    avatar_file: File,

    success = (data: {status: string, data: {avatar: string}}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const formData = new FormData();

    formData.append('file', avatar_file);

    client.post(`/user/avatar`, formData)
        .then(({data}: any) => {
            success(data);
        }).catch((error) => resolveError(error, failed));
}
